import { z } from 'zod';
import { Team } from 'src/api/generated';

export const userStatusFilterSchema = z.enum(['active', 'inactive', 'all']);
export const userProfileFilterSchema = z.enum(['admin', 'agent', 'all']);
export const teamIdFilterSchema = z.union([z.number(), z.literal('all')]);

export type UserStatusFilter = z.infer<typeof userStatusFilterSchema>;
export type UserProfileFilter = z.infer<typeof userProfileFilterSchema>;
export type TeamIdFilter = z.infer<typeof teamIdFilterSchema>;

export interface UserFiltersState {
  status?: UserStatusFilter;
  teamId?: TeamIdFilter;
  profile?: UserProfileFilter;
  search?: string;
}

export interface UserFilterOption {
  value: string;
  label: string;
  count?: number;
}

export interface UserFiltersProps {
  filters: UserFiltersState;
  teams: Team[];
  onFiltersChange: (filters: UserFiltersState) => void;
  onClearFilters: () => void;
}
